var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ficheVIsioVente" },
    [
      _c(
        "div",
        { staticClass: "text-xs-center" },
        [
          !_vm.checkSessionVisioVente && !_vm.timeoutVisioVente
            ? _c(
                "v-btn",
                {
                  attrs: {
                    loading: _vm.loading,
                    disabled:
                      _vm.loading ||
                      !_vm.agentOnline ||
                      !_vm.datasVisiteur.socketID ||
                      !_vm.checkClientVisioVente,
                    color: "success"
                  },
                  nativeOn: {
                    click: function($event) {
                      return _vm.askVisioVente()
                    }
                  }
                },
                [_vm._v("\n        Démarrez la visio vente.\n      ")]
              )
            : !_vm.checkSessionVisioVente && _vm.timeoutVisioVente
            ? _c(
                "v-btn",
                {
                  attrs: { color: "error" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.askVisioVente()
                    }
                  }
                },
                [_vm._v("\n         Reload\n      ")]
              )
            : _vm.checkSessionVisioVente && _vm.timeoutVisioVente
            ? _c(
                "v-btn",
                {
                  attrs: { color: "error" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.stopVisioVente(_vm.datasVisiteur.visiteurID)
                    }
                  }
                },
                [_vm._v("\n         Reload\n      ")]
              )
            : _vm.checkSessionVisioVente &&
              !_vm.timeoutVisioVente &&
              !_vm.checkRemoteStream
            ? _c(
                "v-btn",
                {
                  attrs: { color: "success" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.reAskVisioVente()
                    }
                  }
                },
                [_vm._v("\n        Renvoyer une invitation\n      ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.checkSessionVisioVente && !_vm.timeoutVisioVente
            ? _c(
                "v-btn",
                {
                  attrs: { color: "error" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.stopVisioVente(_vm.datasVisiteur.visiteurID)
                    }
                  }
                },
                [_vm._v("\n         Arretez la visio vente\n      ")]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        {
          attrs: {
            id: "visioVente-layout",
            column: "",
            "align-center": "",
            "justify-center": ""
          }
        },
        [
          _c("div", { attrs: { id: "container" } }, [
            _c("div", { attrs: { id: "conference" } }, [
              !_vm.activeConnexionPeer
                ? _c(
                    "div",
                    [
                      _c(
                        "v-alert",
                        {
                          attrs: {
                            value: true,
                            color: _vm.infosVisioVente.message.color,
                            icon: _vm.infosVisioVente.message.icone,
                            outline: ""
                          }
                        },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.infosVisioVente.message.text) +
                              "\n              "
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("wz-catalogue-produits", {
        on: {
          pushproduct: function(msg) {
            return _vm.$emit("pushproduct", msg)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60e058c0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60e058c0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzVisioVente.vue
// module id = null
// module chunks = 